import { LORAX } from 'HubStyleTokens/colors';
import { CustomLogo, HubSpotSprocket, HubSpotWordmark } from './HeaderLogo.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoBody = ({
  altText,
  showMobileView,
  imageSrc,
  width,
  height
}) => {
  if (imageSrc) {
    return /*#__PURE__*/_jsx(CustomLogo, {
      alt: altText,
      height: height || 40,
      responsive: false,
      src: imageSrc,
      width: width
    });
  }
  if (showMobileView) {
    return /*#__PURE__*/_jsx(HubSpotSprocket, {
      color: LORAX,
      name: "sprocket",
      size: 27
    });
  }
  return /*#__PURE__*/_jsx(HubSpotWordmark, {
    alt: altText,
    name: "hubspot-wordmark",
    width: "128"
  });
};